<div
	class="wrapper show-progress"
	[class.logo-loaded]="logoLoaded$ | async"
	[class.loader-visible]="loaderVisible$ | async"
	[class.app-initialized]="animationFinished$ | async"
>
	<ng-container *ngIf="useLottieInitAnimation; else defaultInitLogo">
		<div
			class="loader-wrapper pos-res"
			style="max-width: 100%; width: 800px; height: 300px; max-height: 100%"
		>
			<lottie-animation
				[path]="initLottiePath"
				[loop]="false"
				[autoplay]="false"
				(finished)="logoLoaded()"
			></lottie-animation>
		</div>
	</ng-container>

	<ng-template #defaultInitLogo>
		<div class="loader-wrapper" style="max-width: 80%; width: 284px">
			<img
				class="left-as-is"
				style="width: 205px; height: 40px"
				src="/assets/images/logo/logo-white-with-text.png"
				alt="myReach"
				width="205"
				height="40"
				(load)="logoLoaded()"
			/>

			<div
				class="pos-abs pos-b-0 pos-l-0 w-100 p-3-rl border-box fl fl-ai-c fl-jc-c"
				style="transform: translateY(100%)"
			>
				<div class="loader-indicator"></div>
			</div>
		</div>
	</ng-template>

	<div class="transition-wrapper"></div>
</div>
